import styled from "@emotion/styled";

export const TrackContentWrapper = styled.div`
  position: relative;
  padding-bottom: 5px;
`;

export const TrackHeaderWrapper = styled.div`
  background-color: transparent;
  display: flex;
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; /* for truncate */
  padding-right: 0.5rem; /* for pr-2 (0.5rem = 8px) */
  padding-left: 1rem; /* for pl-4 (1rem = 16px) */
  font-size: 0.75rem; /* for text-xs (0.75rem = 12px) */
  color: grey; /* for text-gray-200 */
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  color: grey;
  @media (min-width: 640px) {
    /* for sm: breakpoint */
    padding-left: 2rem; /* for sm:pl-8 (2rem = 32px) */
  }
`;
